module.exports = __webpack_public_path__ + "img/tsonev.b306d819.jpg";